<nz-spin
  nzTip="Authenticating. Please wait..."
  [nzSpinning]="isLoading"
  [nzSize]="'large'"
  style="top: 50%"
>
</nz-spin>
<router-outlet *ngIf="shouldLoadModules"></router-outlet>
